<template>
  <MainLayout style="color: var(--text-color, #fff);">
    <template #content>
      <div class="flex flex-col w-full">

        <div class="bg-white flex flex-col items-center px-4 py-20 text-black -mt-5">
          <div class="w-9/12 mx-auto text-center py-5">
            <div class="font-medium mb-2 text-3xl mb-5">Diese Homepage wird zur Verfügung gestellt von Epasnets GmbH</div>
            <a href="https://about.epasnets.com/impressum/" target="_blank" class="company-bg-color px-5 py-3 rounded-md text-sm text-white">zum Impressum</a>
          </div>
        </div>
        <div class="bg-white flex flex-col items-center px-4 py-20 text-black">
          <div class="w-9/12 mx-auto text-center">
            <div class="font-medium mb-2 text-3xl">Verantwortlich für den Inhalt</div>
            <div
              v-if="!USER.is_tourism"
              class="mb-6"
            >
              {{ USER.company.name }}, {{ USER.detail.address }}, {{ USER.detail.zip_code }}, {{ USER.detail.city }}
            </div>
            <div
              v-else
              class="mb-6"
            >
              <p>Arbeitsgruppe Vordertaler Zukunft</p>
              <p>c/o Ötztal Tourismus</p>
              <p>Hauptstraße 66</p>
              <p>6433 Oetz</p>
            </div>
            <a v-if="USER.company.link" :href="USER.company.link" target="_blank" class="company-bg-color px-5 py-3 rounded-md text-sm text-white">zum Impressum</a>
          </div>
        </div>
        <div
          v-if="USER.is_tourism"
          class="bg-gray-100"
        >
          <div class="grid grid-cols-1 md:grid-cols-2 px-5 lg:grid-cols-3 gap-10 py-20 max-w-screen-xl mx-auto">
            <div
              v-for="partner in partners"
              :key="partner"
              class="bg-white"
              style="box-shadow: 0 3px 10px rgb(0,0,0,0.2);"
            >
              <div class="flex font-semibold gap-10 h-24 items-center justify-between p-5 text-black text-sm">
                {{ partner.username }}
                <img
                  v-if="partner.company.logo"
                  :src="onSetImage(partner.company.logo)"
                  alt="partner logo"
                  class="w-24"
                >
              </div>

              <VueSlickCarousel
                v-bind="voucherOption"
              >
                <div
                  v-for="v in partner.employee_vouchers"
                  :key="v"
                >
                  <img
                    :src="onSetImage(v.data_json.background_image)"
                    alt="Employee Vouchers"
                  >
                  <div class="flex flex-col py-5 text-black text-center">
                    <span class="font-bold">{{ v.title }}</span>
                    <span>{{ v.employee_value }}</span>
                  </div>
                </div>
              </VueSlickCarousel>

              <!-- <div class="h-full flex items-center justify-center">
                <ul class="text-black list-disc">
                  <li v-for="v in partner.employee_vouchers">
                    {{ v.title }}
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
        <div class="content-container flex flex-col md:flex-row w-full gap-6 px-6 mb-10">
          <form action="" class="form bg-white p-6 my-10 relative text-black w-full md:w-1/2" @submit.prevent="onSubmitForm">
                <h3 class="text-2xl company-color font-semibold">Kontaktiere uns.</h3>
                <input name="seller_email" type="hidden" v-model="USER.email">
                <div class="flex space-x-5 mt-3">
                    <input name="name" type="text" required placeholder="Name" class="border p-2  w-1/2">
                    <input name="tel" type="tel" placeholder="Telefonnummer" class="border p-2 w-1/2">
                </div>
                <input name="email" type="email" required placeholder="Email" class="border p-2 w-full mt-3">
                <textarea name="content" required cols="10" rows="3" placeholder="Hier ist Platz für das Anliegen / die Nachricht." class="border p-2 mt-3 w-full"></textarea>
                <div class="flex items-baseline space-x-2 mt-2">
                    <input type="checkbox" required class="inline-block">
                    <p class="text-gray-600 text-sm">Ich akzeptiere die Verarbeitung meiner Daten zum Zweck der Kontaktanfrage gemäß Datenschutzerklärung.</p>
                </div>
                <input ref="submit"  type="submit" value="Abschicken" class="w-full mt-6 company-bg-color px-5 py-3 rounded-md text-sm text-white">
            </form>
            <div class="flex items-center justify-center md:w-1/2 w-full">
              <a class="flex justify-center max-w-xs w-full" :href="appURL">
                <img class="self-center" src="@/_assets/img/header.svg" alt="" />
              </a>
            </div>
          </div>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import MainLayout from '_layouts/subdomain';
import VoucherList from '_components/List/Modules/VoucherList/';
import { post } from '_helpers/ApiService'
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  components: {
    MainLayout,
    VoucherList,
    VueSlickCarousel
  },
  data() {
    return {
      isLoading: true,
      isShowMore: false,
      appURL: '',
      partners: [],
      voucherOption: {
        arrows: false,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        rows: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        draggable: false,
      },
    };
  },
  computed: {
    AUTH_USER() {
      return this.$store.getters.AUTH_USER;
    },
    VOUCHERS() {
      return this.$store.getters.SELLER_VOUCHERS;
    },
    USER() {
      return this.$store.getters.COMPANY;
    },
    IS_LOADING() {
      return this.$store.getters.IS_LOADING;
    },
  },
  watch: {},
  mounted() {
    (async () => {
      this.appURL = process.env.VUE_APP_WEB_URL
      try {
        await this.$store.commit('SET_IS_LOADING', { status: 'open' });
        await this.$store.commit('SET_SELLER_VOUCHERS', []);
        await this.onFetchVouchers();
        await this.$store.commit('SET_IS_LOADING', { status: 'close' });
      } catch (err) {
        await this.$store.commit('SET_IS_LOADING', { status: 'close' });
      }
    })();

    this.fetchActivePartners()
  },
  methods: {
    async onSubmitForm(evt) {
      let formData = new FormData(evt.target)
      this.$refs.submit.value = 'Loading...'
      this.$refs.submit.disabled = true
      await post(`contact`, formData)
      this.$swal({
        title: 'Erfolgreich abgeschickt. Wir melden uns in Kürze!',
        text: '',
        allowOutsideClick: true,
        confirmButtonColor: '#48BB78',
        timer: 2000,
        timerProgressBar: true,
      })
      this.$refs.submit.value = 'Abschicken'
      this.$refs.submit.disabled = false
      evt.target.reset()
    },
    async fetchActivePartners() {
      try {
        await this.$store.commit('SET_CODES', [])
        await this.$store.commit('SET_IS_LOADING', { status: 'open' })

        const { partners } = await this.$store.dispatch('FETCH_ACTIVE_PARTNERS_W_VOUCHERS')

        this.partners = partners

        await this.$store.commit('SET_IS_LOADING', { status: 'close' })
      } catch(error) {
        await this.$store.commit('SET_IS_LOADING', { status: 'close' })
      }
    },
    onSetImage(value) {
      if (!value) {
        return false
      }

      return value.search('base64') < 0
        ? `${process.env.VUE_APP_API_BASE_URL}/storage/${value}`
        : value;
    },
  },
};
</script>

<style scoped>
 [disabled] {
   @apply opacity-50;
 }
</style>